import {Spin} from 'antd'
import React, {ComponentType, FC, useMemo, useState} from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'
import HttpService from 'src/core/services/http.service'
import {container} from 'src/inversify.config'
import {IdentityProps, withIdentity} from '../core/services/authentication'

var logo = require('src/core/assets/logo.png')

export interface companyProfile {
  employeeId: string
  employeeTitle: string
  identityName: string
  companyId: string
  companyTitle: string
  isManager: boolean
  isCompanyManager: boolean
  hasRoleAdminOrManager: boolean
  currency: string
  cirEligible: boolean
  ciiEligible: boolean
  pendingCount: number
  isFutureAllowed: boolean
}

export interface UserProfile {
  roles: string[]
  companies: companyProfile[]

}

const { Provider, Consumer } = React.createContext<UserProfile>(undefined as any)

export interface UserProfileSecureShellProps extends WithTranslation, IdentityProps {
  serviceUrl: string
  loadingView?: JSX.Element
  errorView?: JSX.Element
  onUserProfileReceived?: (profile: UserProfile) => void
}

const UserProfileSecureShell: FC<UserProfileSecureShellProps> = ({
  serviceUrl,
  loadingView,
  errorView,
  identity,
  t,
  onUserProfileReceived,
  children,
}) => {
  const [status, setStatus] = useState<'LOADING' | 'OK' | 'ERROR'>('LOADING')
  const [profile, setProfile] = useState<UserProfile>()
  const httpService = container.get<HttpService>(HttpService)

  useMemo(() => {
    setStatus('LOADING')
    let currentRoles: string[] = []
    httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/roles`).then((result: { data: { roles: string[] } }) => {
      let roles = identity.roles != undefined ? [...identity.roles, ...result.data.roles as string[]] : [...result.data.roles as string[]]
      currentRoles = roles
      httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/profile`).then((result: { data: any[] }) => {
        if (!result.data || result.data.length == 0) {
          setProfile({ roles: currentRoles, companies: [] })
          setStatus("OK")
        } else {
          var companies = result.data.map((o: any) => ({
            employeeId: o.employeeId,
            employeeTitle: o.employeeTitle,
            identityName: o.identityName,
            companyId: o.companyId,
            companyTitle: o.companyTitle,
            isManager: o.isManager,
            isCompanyManager: o.isCompanyManager,
            hasRoleAdminOrManager: o.hasRoleAdminOrManager,
            currency: o.currency,
            cirEligible: o.cirEligible,
            ciiEligible: o.ciiEligible,
            pendingCount: o.pendingCount,
            isFutureAllowed: o.isFutureAllowed 

          }))
          setProfile({ roles: currentRoles, companies: companies })
          setStatus("OK")
        }
      }).catch(error => {
        setStatus("ERROR")
      })
     

    }).catch(error => {
      setStatus("ERROR")
    })


  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  const loadEmployeeId = () => {


  }

  if (status === 'LOADING')
    return (
      loadingView || (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            height: '100px',
            marginTop: '-50px',
            marginLeft: '-200px',
            width: '400px',
            textAlign: 'center',
          }}
        >
          <div style={{ marginLeft: '55px', marginBottom: '10px', display: 'flex' }}>
            <Spin style={{ marginRight: '10px', marginTop: 'auto', marginBottom: 'auto' }} />{' '}
            <img style={{ background: 'rgb(0,0,164)', padding: '4px 4px 4px 4px', marginTop: 'auto', marginBottom: 'auto' }} alt="fi-logo" src={logo} height={34} />
            <span style={{ fontSize: 18, float: 'right', marginTop: 'auto', marginBottom: 'auto', marginLeft: 5, fontWeight: 'bold', color: '#0000a4' }}>
              Helping ideas grow
            </span>
          </div>

          <strong style={{ marginLeft: '10px', display: 'none' }}>{t('Loading TMS Application...')}</strong>
        </div>
      )
    )
  if (status === 'ERROR')
    return (
      errorView || (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            height: '100px',
            marginTop: '-50px',
            marginLeft: '-150px',
            width: '300px',
            textAlign: 'center',
          }}
        >
          <h1>{t('ERROR')}</h1>
          <p>{t("You don't have access to this application, please contact your Administrator...")}</p>
        </div>
      )
    )
  if (status === 'OK') {
    return <Provider value={{ roles: (profile?.roles || []), companies: profile?.companies || [] }}>{children}</Provider>
  }
  return null
}

export interface UserProfileProps {
  userProfile: UserProfile
}
const withUserProfile = <T extends ComponentType<any>>(Component: T) => {
  return (props: any) => {
    return <Consumer>{(userProfile) => <Component {...props} userProfile={userProfile} />}</Consumer>
  }
}

export const userHasRole = ( userProfile : UserProfile , rolesToCheck: any) => {
    return rolesToCheck.some((role: any) => userProfile.roles.includes(role));
};

export default withIdentity(withTranslation()(UserProfileSecureShell) as any)
export { withUserProfile }
